export const formContentStyle = {
	wrapper: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		gap: '12px',
		marginBottom: '24px',

		'@media (max-width: 639.98px)': {
			marginBottom: '20px',
		},
	},

	form: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		gap: '24px',

		'@media (max-width: 1023.98px)': {
			gap: '20px',
		},

		'@media (max-width: 639.98px)': {
			gap: '16px',
		},
	},

	content: {
		display: 'flex',
		flexDirection: 'column',
		flex: '1 1',
		gap: '24px',

		'@media (max-width: 1023.98px)': {
			gap: '20px',
		},

		'@media (max-width: 639.98px)': {
			gap: '16px',
		},
	},

	detailsWrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
	},

	sceheduleWrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
	},

	urlWrapper: {
		display: 'flex',
		gap: '24px',
		width: '100%',
		alignItems: 'flex-start',

		'@media (max-width: 1023.98px)': {
			flexDirection: 'column',
			gap: '12px',
		},
	},

	fieldHalf: {
		flex: 1,
		minWidth: 0,
		width: '100%',

		'@media (max-width: 1023.98px)': {
			flex: 'none',
		},
	},

	urlPrefix: {
		fontSize: '16px',
		color: 'var(--neutral-500)',
		userSelect: 'none',
		whiteSpace: 'nowrap',
		display: 'flex',
		alignItems: 'center',
		mr: '-12px',

		'@media (max-width: 639.98px)': {
			fontSize: '12px',
			mr: '-8px',
		},
	},

	amount: {
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
	},

	title: {
		marginTop: '8px',

		'@media (max-width: 639.98px)': {
			marginTop: 0,
		},
	},

	brandingWrapper: {
		display: 'flex',
		gap: '12px',
		width: '100%',
		alignItems: 'flex-start',

		'@media (max-width: 1023.98px)': {
			flexDirection: 'column',
			gap: '16px',
		},

		'@media (max-width: 639.98px)': {
			gap: '12px',
		},
	},

	logoWrapper: {
		height: '120px',
		marginBottom: '20px',
		paddingBottom: '8px',
		flex: '1',
		minWidth: 0,

		'@media (max-width: 1023.98px)': {
			flex: 'none',
			width: '100%',
			maxWidth: '100%',
		},

		'@media (max-width: 639.98px)': {
			minHeight: '120px',
			marginBottom: '16px',
			paddingBottom: '8px',
		},
	},

	logoHint: {
		fontSize: '10px',
		fontWeight: 400,
		color: 'var(--neutral-300)',
		marginTop: '-4px',
	},

	colorField: {
		flex: 1,
		minWidth: 0,
		width: '100%',

		'@media (max-width: 1023.98px)': {
			flex: 'none',
		},
	},

	goalRow: {
		display: 'flex',
		gap: '12px',
		alignItems: 'flex-start',
		flex: '1',
		minWidth: 0,

		'@media (max-width: 1023.98px)': {
			flex: 'none',
			width: '100%',
		},

		'@media (max-width: 639.98px)': {
			flexWrap: 'wrap',
			alignItems: 'center',
		},
	},

	goalField: {
		flex: 1,
		minWidth: 0,

		'@media (max-width: 639.98px)': {
			width: '100%',
			flex: 'none',
		},
	},

	goalHint: {
		color: 'var(--neutral-300)',
		fontSize: '10px',
		marginTop: '-4px',
	},

	goalAmount: {
		maxWidth: '417px',
		width: '100%',

		'@media (max-width: 1023.98px)': {
			maxWidth: '100%',
		},

		'&.MuiFormControl-root .MuiInputBase-root input': {
			padding: '0 12px 0 0',
		},
	},

	goalAmountIcon: {'& .MuiTypography-root': {color: 'var(--neutral-300)'}},

	goalSwitch: {
		marginTop: '20px',

		'@media (max-width: 639.98px)': {
			marginTop: 0,
		},
	},

	description: {
		maxWidth: '100%',

		'&.MuiFormControl-root .MuiInputBase-root': {
			height: '100%',
			maxHeight: '290px',
		},
	},

	logo: {
		marginTop: '20px',
		maxHeight: '120px',

		'& .MuiFormLabel-root': {
			position: 'absolute',
			top: '-20px',
		},
	},

	locationWrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
	},

	dateWrapper: {
		display: 'flex',
		gap: '24px',
		width: '100%',

		'@media (max-width: 1023.98px)': {
			flexDirection: 'column',
			gap: '16px',
		},

		'@media (max-width: 639.98px)': {
			gap: '12px',
		},
	},

	date: {
		display: 'flex',
		gap: '12px',
		alignItems: 'center',

		'& > div': {
			width: 'auto',
		},

		'@media (max-width: 639.98px)': {
			flexDirection: 'column',
			alignItems: 'stretch',

			'& > div': {
				width: '100%',
			},
		},
	},

	dateMonthYear: {
		'.MuiInputBase-root': {paddingRight: '0px !important'},
		'.MuiInputBase-input': {padding: '0 0 0 6px !important'},
		'@media (max-width: 639.98px)': {
			maxWidth: '100%',
			width: '100%',
		},
	},

	time: {
		'& > div:first-of-type': {maxWidth: '120px', width: '120px'},

		'@media (max-width: 639.98px)': {
			'& > div:first-of-type': {maxWidth: '100%', width: '100%'},
		},
	},

	loader: {
		position: 'absolute',
		left: '50%',
		top: '50%',
		transform: 'translate(-50%, -50%)',
	},
};
